import React, { useState } from "react";
import { Button, Input, Tooltip } from "antd";
import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import ModalItem from "./ModalItem";

const { TextArea } = Input;

const EditableTextAreaModal = ({ // Props con valores predeterminados
  label = "Texto",
  value = "",
  onSave,
  tooltip,
  buttonText = "Agregar",
  buttonSize = "small",
  buttonType = "default",
  modalTitle,
  placeholder,
  rows = 4,
  maxLength,
  showCount = false,
  disabled = false,
  isViewMode = false, // Nuevo prop para modo ver
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tempValue, setTempValue] = useState("");

  const showModal = () => { // Muestra el modal y establece el valor temporal
    setTempValue(value || "");
    setIsModalVisible(true);
  };

  const handleOk = () => { // Guarda el valor y cierra el modal
    if (onSave) {
      onSave(tempValue);
    }
    setIsModalVisible(false);
  };

  const handleCancel = () => { // Cierra el modal sin guardar
    setIsModalVisible(false);
    setTempValue(value || "");
  };

  return ( 
    <>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8 }}>
          <span style={{ fontSize: "12px", fontWeight: 500, color: "#666" }}>
            {label}
            {tooltip && (
              <Tooltip title={tooltip}>
                <InfoCircleOutlined style={{ marginLeft: 4, fontSize: "10px", color: "#999", cursor: "help" }} />
              </Tooltip>
            )}
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
          {value ? (
            <div
              style={{
                padding: "8px 11px",
                fontSize: "11px",
                border: "1px solid #d9d9d9",
                borderRadius: "2px",
                backgroundColor: "#f5f5f5",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                flex: 1,
              }}
            >
              {value}
            </div>
          ) : (
            <div
              style={{
                padding: "4px 8px",
                fontSize: "10px",
                border: "1px dashed #d9d9d9",
                borderRadius: "2px",
                backgroundColor: "#fafafa",
                color: "#bfbfbf",
                fontStyle: "italic",
                display: "inline-block",
              }}
            >
              Sin contenido
            </div>
          )}
          <Button
            size={buttonSize}
            type={buttonType}
            icon={<EditOutlined />}
            onClick={showModal}
            disabled={disabled || isViewMode}
          >
            {buttonText}
          </Button>
        </div>
      </div>

      <ModalItem
        title={modalTitle || `Editar ${label}`}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Aceptar"
        cancelText="Cancelar"
        width={600}
        spinning={false}
        footer
      >
        <TextArea
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
          placeholder={placeholder || `Ingrese ${label.toLowerCase()}...`}
          rows={rows}
          maxLength={maxLength}
          showCount={showCount}
          autoFocus
          style={{ marginTop: 10 }}
        />
      </ModalItem>
    </>
  );
};

export default EditableTextAreaModal;